export default "__VITE_ASSET__l8nF8HKZ__"